import { render, staticRenderFns } from "./ForeignTaxReport.vue?vue&type=template&id=23d341f9&scoped=true&"
import script from "./ForeignTaxReport.vue?vue&type=script&lang=js&"
export * from "./ForeignTaxReport.vue?vue&type=script&lang=js&"
import style0 from "./ForeignTaxReport.vue?vue&type=style&index=0&id=23d341f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d341f9",
  null
  
)

export default component.exports